import request from '@/utils/request'
import { objectToFormData } from '@/utils/util'
// import formRequest from '@/utils/request/formRequest'
// #c0c4cc
// 新增备案信息
export function createFilings(params: any) {
    return request.post({
        url: '/filings.Filings/createFilings',
        params: objectToFormData(params)
    })
}

// 备案号新增网站
export function createWebsite(params: any) {
    return request.post({
        url: '/filings.Filings/createWebsite',
        params: objectToFormData(params)
    })
}

// 获取主办单位类型
export function getOrganizerIdType(params: any) {
    return request.get({ url: '/filings.Filings/getOrganizerIdType', params })
}

// 备案信息列表
export function getFilingsLists(params: any) {
    return request.get(
        { url: '/filings.Filings/lists', params },
        { ignoreCancelToken: true }
    )
}

// 备案信息详情
export function getFillingsDetail(params: any) {
    return request.get({ url: '/filings.Filings/detail', params })
}

// 备案信息材料变更
export function saveUplodeFile(params: any) {
    return request.post({
        url: '/filings.Filings/saveUplodeFile',
        params
    })
}

// 变更单个材料
export function saveUniqueFile(params: any) {
    return request.post({
        url: '/filings.Filings/saveUniqueFile',
        params
    })
}

// 修改备案状态
export function saveFilingsStatus(params: any) {
    return request.post({
        url: '/filings.Filings/confirm',
        params: objectToFormData(params)
    })
}

// 删除备案
export function deleteFilings(params: any) {
    return request.delete({
        url: '/filings.Filings/deleteFilings',
        params
    })
}

// 动态获取备案信息 变更备案用
export function saveDetail(params: any) {
    return request.get({
        url: '/filings.Filings/saveDetail',
        params
    })
}

// 变更备案（备案成功后）
export function saveFilings(params: any) {
    return request.post({
        url: '/filings.Filings/saveFilings',
        params: objectToFormData(params)
    })
}

// 取消变更备案
export function cancelSave(params: any) {
    return request.post({
        url: '/filings.Filings/cancelSave',
        params
    })
}

// 更改代理商
export function saveAdmin(params: any) {
    return request.post({
        url: '/filings.Filings/saveAdmin',
        params
    })
}

// 删除网站
export function deleteWebsite(params: any) {
    return request.delete({
        url: '/filings.Filings/deleteWebsite',
        params
    })
}
// 核查网站域名
export function checkWebsiteDomain(params: any) {
    return request.post({
        url: '/filings.Filings/checkWebsiteDomain',
        params
    })
}

// 修改备案信息
export function updateFilings(params: any) {
    return request.post({
        url: '/filings.Filings/updateFilings',
        params: objectToFormData(params)
    })
}

// 提交核实信息
export function commitVerify(params: any) {
    return request.post({
        url: '/filings.Filings/commitVerify',
        params
    })
}

// 批量提交核实信息
export function batchCommitVerify(params: any) {
    return request.post({
        url: '/filings.Filings/batchCommitVerify',
        params
    })
}

// 省份备案规则资讯表列表
export function apiArticleAddressLists(params: any) {
    return request.get({ url: '/article_address/lists', params })
}

// 添加省份备案规则资讯表
export function apiArticleAddressAdd(params: any) {
    return request.post({ url: '/article_address/add', params })
}

// 编辑省份备案规则资讯表
export function apiArticleAddressEdit(params: any) {
    return request.post({ url: '/article_address/edit', params })
}

// 删除省份备案规则资讯表
export function apiArticleAddressDelete(params: any) {
    return request.delete({ url: '/article_address/delete', params })
}

// 省份备案规则资讯表详情
export function apiArticleAddressDetail(params: any) {
    return request.get({ url: '/article_address/detail', params })
}

// 上交到管局
export function submitFilings(params: any) {
    return request.post({ url: '/filings.Filings/submitFilings', params })
}

// 同步管局代码数据
export function synchronousData() {
    return request.post({ url: '/filings.Filings/synchronousData' })
}

// 验证备案
export function checkFilings(params: any) {
    return request.post({ url: '/filings.Filings/checkFilings', params })
}

// 新增接入
export function createAccess(params: any) {
    return request.post({ url: '/filings.Filings/createAccess', params })
}

// 网站备案号查询接入
export function checkAccessMulti(params: any) {
    return request.post({
        url: '/filings.Filings/checkAccessMulti',
        params
    })
}

// 主体备案号获取主体信息
export function checkMainBody(params: any) {
    return request.get({
        url: '/filings.Filings/checkMainBody',
        params
    })
}

// 备案状态查询
export function queryStatus(params: any) {
    return request.post({
        url: '/filings.Filings/queryStatus',
        params
    })
}

// 修改接入
export function updateAccess(params: any) {
    return request.post({
        url: '/filings.Filings/updateAccess',
        params
    })
}

// 新的备案状态查询
export function queryStatusScene() {
    return request.get({
        url: '/filings.Filings/queryStatusScene'
    })
}

// 取消接入
export function cancelAccess(params: any) {
    return request.post({
        url: '/filings.Filings/cancelAccess',
        params
    })
}

// 删除接入记录
export function delMainAccessLog(params: any) {
    return request.post({
        url: '/filings.Filings/delMainAccessLog',
        params
    })
}

// 变更接入
export function saveAccess(params: any) {
    return request.post({
        url: '/filings.Filings/saveAccess',
        params
    })
}

// 注销接入
export function logOffFilings(params: any) {
    return request.post({
        url: '/filings.Filings/logOffFilings',
        params
    })
}

// 注销服务列表
export function logOffLists(params: any) {
    return request.get({
        url: '/filings.Filings/logOffLists',
        params
    })
}

// 无服务主体查询
export function noServerMainList(params: any) {
    return request.get({
        url: '/filings.Filings/noServerMainList',
        params
    })
}

// 注销主体列表
export function logOffMainLists(params: any) {
    return request.get({
        url: '/filings.Filings/logOffMainLists',
        params
    })
}

// 申请注销服务列表
export function logOffServiceLists(params: any) {
    return request.get({
        url: '/filings.Filings/logOffServiceLists',
        params
    })
}

// 服务域名列表
export function domainStatusList(params: any) {
    return request.get(
        {
            url: '/filings.Filings/domainStatusList',
            params
        },
        { ignoreCancelToken: true }
    )
}

// 取消上交
export function canceLogOffFilings(params: any) {
    return request.post({
        url: '/filings.Filings/canceLogOffFilings',
        params
    })
}

// 确定上交
export function logOffCommit(params: any) {
    return request.post({
        url: '/filings.Filings/logOffCommit',
        params
    })
}

// 备案完结
export function payStatus(params: any) {
    return request.post({
        url: '/filings.Filings/payStatus',
        params
    })
}

// 退回到待确认
export function updateStatus(params: any) {
    return request.post({
        url: '/filings.Filings/updateStatus',
        params
    })
}

// 获取解析ip信息
export function websiteBodyLists(params: any) {
    return request.get(
        {
            url: '/filings.WebsiteBody/lists',
            params
        },
        { ignoreCancelToken: true }
    )
}

// 重新生成备案承诺书和真实性核验单
export function genValidityImage(params: any) {
    return request.post({
        url: '/filings.Filings/genValidityImage',
        params
    })
}

// 删除服务注销记录
export function delLogOff(params: any) {
    return request.post({
        url: '/filings.Filings/delLogOff',
        params
    })
}

// 指定服务解析ip列表
export function getAnalysisIpList(params: any) {
    return request.get(
        { url: '/filings.Filings/analysisIpList', params },
        { ignoreCancelToken: true }
    )
}

// 获取违规内容记录
export function contentIllegalList(params: any) {
    return request.get(
        {
            url: '/filings.Filings/contentIllegalList',
            params
        },
        { ignoreCancelToken: true }
    )
}

// 设置违规内容处理状态
export function changeParseContentStatus(params: any) {
    return request.post({
        url: '/filings.Filings/changeParseContentStatus',
        params
    })
}

// 删除主体注销记录
export function delMainLogOff(params: any) {
    return request.post({
        url: '/filings.Filings/delMainLogOff',
        params
    })
}

// 修改服务首页地址
export function modifyWebsite(params: any) {
    return request.post({
        url: '/filings.Filings/modifyWebsite',
        params
    })
}

// 查询首页是否在系统中存在
export function mainExistence(params: any) {
    return request.post({
        url: '/filings.Filings/mainExistence',
        params
    })
}

// 批量注销域名
export function logOffFilingsBatch(params: any) {
    return request.post({
        url: '/filings.Filings/logOffFilingsBatch',
        params
    })
}

// 主体核查列表
export function mainExamineList(params: any) {
    return request.get({
        url: '/filings.Filings/mainExamineList',
        params
    })
}

// 服务核查列表
export function serverExamineList(params: any) {
    return request.get({
        url: '/filings.Filings/serverExamineList',
        params
    })
}

// 批量发送通知
export function batchSendFililngAbarbeitungNotice(params: any) {
    return request.post({
        url: '/filings.Filings/batchSendFililngAbarbeitungNotice',
        params
    })
}

// 获取可批量删除的服务
export function deletableServerLists(params: any) {
    return request.get({
        url: '/filings.Filings/deletableServerLists',
        params
    })
}

// 获取已注销服务列表
export function webBodyLogOffLists(params: any) {
    return request.get({
        url: '/filings.Filings/webBodyLogOffLists',
        params
    })
}
